import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
import { MenuItem } from "@sprout/list-navigation/dist/Menu";
import { LocalOfferTwoTone as BaseLocalOfferTwoTone } from "sprout-ui-icons";
import { themeGet } from "sprout-ui-theme";
import styled from "styled-components";
const LocalOfferTwoTone = styled(BaseLocalOfferTwoTone)`
  path:nth-child(2) {
    fill: ${({ $color  })=>$color};
    stroke: ${themeGet("colors.white.100")};
    stroke-width: 1;
  }
`;
const TopicPageViewsTopicMenuLabels = (props)=>{
    const { labels , rootURL  } = props;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: labels.map((label)=>{
            return /*#__PURE__*/ _jsx(MenuItem, {
                icon: /*#__PURE__*/ _jsx(LocalOfferTwoTone, {
                    $color: colorMap[label.style]
                }),
                label: label.text || "",
                to: `${rootURL}/label/${label.id}`
            }, label.nodeId);
        })
    });
};
export default TopicPageViewsTopicMenuLabels;
